export default __webpack_public_path__ + "static/media/tb-team-nikos.538ebe93.gif";